import Vue from "vue";
import FBSignInButton from "vue-facebook-signin-button";

Vue.use(FBSignInButton);
